import { render, staticRenderFns } from "./magazine-select-search.component.vue?vue&type=template&id=afb86512"
import script from "./magazine-select-search.component.vue?vue&type=script&lang=ts"
export * from "./magazine-select-search.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports